// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
// import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
// import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
// import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import PortalVue from 'portal-vue'
// import Chartist from 'vue-chartist'
import './plugins/chartist'
import './plugins/axios'
import './plugins/base'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

window.axios = axios
// axios.defaults.baseURL = 'http://service.admanager.yobee.lo/api/v1'
// console.log(localStorage.getItem('auth'))
// axios.defaults.baseURL = 'http://service.admanager.yobee.lo/api/v1/'
// axios.defaults.baseURL = 'http://staging.admin.yobee.it/api/v1/'
axios.defaults.baseURL = 'https://admin.yobee.it/api/v1/'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth');
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  // Do something with response error
  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
    //  */
    // console.log("response.data: ",error.response.data);
    // console.log("resposne.status: ",error.response.status);
    // console.log("response.header: ",error.response.headers);


    switch (error.response.status) {
      case 401:
        store.commit('logout')
        router.replace('/login')
        break
      default:
        console.log('Unhandled response status: ', error.response.status)
        break
    }

  } else if (error.request) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    // console.log(error.request);
  } else {
    // Something happened in setting up the request and triggered an Error
    // console.log('Error', error.message);
  }

  return Promise.reject(error)

})

Vue.config.productionTip = false

Vue.use(vuetify)
Vue.use(PortalVue)
// Vue.use(require('vue-chartist'))

new Vue({
  router,
  store,
  vuetify,
  PortalVue,
  // chartist,
  render: h => h(App)
}).$mount('#app')
